import './satisfaction-survey-form.scss';
import './satisfaction-survey-form.js';
